import {FormControl, FormGroup} from '@angular/forms';
import moment from 'moment';

export class FormUtils {

  /**
   * Build form data from javascript object using parentKey as a prefix for a formdata key
   */
  static buildFormData(formData, data, parentKey = null): void {
    if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File) && !(data instanceof moment)) {
      if (Array.isArray(data)) {
        Object.keys(data).forEach(key => {
          const parentKeyTemp = parentKey ? `${parentKey}[${key}]` : key;
          this.buildFormData(formData, data[key], parentKeyTemp);
        });
      } else {
        Object.keys(data).forEach(key => {
          const newParentKey = parentKey ? `${parentKey}.${key}` : key;
          this.buildFormData(formData, data[key], newParentKey);
        });
      }
    } else if (data !== null && data !== undefined && !(data instanceof moment)) {
      formData.append(parentKey, data);
    }
  }

  /**
   * Build form data from javascript object.
   * It should be used when uploading document.
   */
  static objectToFormData(data): FormData {
    const formData = new FormData();

    this.buildFormData(formData, data);

    return formData;
  }

  /**
   * Validates all fields for provided formGroup
   * @param formGroup Form group that will be validated
   */
  static validateAllFormFields(formGroup: FormGroup): void {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({onlySelf: true});
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }
}
